import React from "react";
import {
  TrendingUp, Utensils, Salad, Sparkles, Dumbbell,
  Zap, Activity, Leaf, Ban, FlaskConical,
} from "lucide-react";

// Order matches the exact list requested — 10 items.
const items = [
  { icon: TrendingUp,   title: "Healthy Weight Gain" },
  { icon: Utensils,     title: "Improved Appetite" },
  { icon: Salad,        title: "Better Digestion" },
  { icon: Sparkles,     title: "Better Nutrient Absorption" },
  { icon: Dumbbell,     title: "Strength Support" },
  { icon: Zap,          title: "Improved Stamina" },
  { icon: Activity,     title: "Lean Muscle Support" },
  { icon: Leaf,         title: "100% Ayurvedic" },
  { icon: Ban,          title: "No Steroids" },
  { icon: FlaskConical, title: "No Chemicals" },
];

export default function Benefits() {
  return (
    <section className="relative bg-gradient-to-b from-black via-[#0a0603] to-black px-5 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FF7A00]">Benefits</div>
          <h2 className="mt-2 font-display text-4xl text-white sm:text-5xl">
            Built To <span className="text-fire">Perform</span>
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-5">
          {items.map(({ icon: Icon, title }) => (
            <div
              key={title}
              className="glass group flex flex-col items-start gap-3 rounded-2xl p-4 transition-transform hover:-translate-y-0.5 sm:p-5"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-fire text-black sm:h-11 sm:w-11">
                <Icon size={20} />
              </div>
              <div className="font-display text-base leading-tight text-white sm:text-lg">
                {title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
